import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { SET_ACCESS_ERROR } from 'redux/slices/account';

import { MODAL_OPEN } from 'redux/slices/modals';

import EditAccountData from 'ui/components/Modals/EditAccountData';

import Account from 'ui/assets/img/account.svg';
import Creator from 'ui/assets/img/creator.svg';
import Role from 'ui/assets/img/role.svg';
import AccountCard from 'ui/atoms/AccountCard';
import MainFont from 'ui/typography/mainFont';
import { extractDate } from 'utils/date-format';

import { partnerRoleOptions, partnerRoles } from '../../const';

import { CardContainer, PageTitle } from './style';
import ChangeAccountPasswordModal from 'ui/components/Modals/ChangeAccountPasswordModal';

const AccountManagement = ({
  account,
  saveChangePasswordType,
  openEditAccountModal,
  serviceStatus,
  setError,
  clearNotification,
  responseStatus,
  role,
  openChangePasswordModal
}) => {
  const { t } = useTranslation();

  const handleChangePassword = () => {
    setError('');
    openChangePasswordModal();
  };

  const handleEditAccountData = () => {
    setError('');
    openEditAccountModal('editAccountData');
  };

  const isDisabled = () => !account?.email;

  return (
    <>
      <PageTitle>
        <MainFont configuration={{ fontSize: 24, fontWeight: 'bold' }}>
          {t('account')}
        </MainFont>
      </PageTitle>
      {/* <PageInfo>
        <MainFont configuration={{ fontSize: 16 }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </MainFont>
      </PageInfo> */}
      <CardContainer>
        <AccountCard
          img={Account}
          firstTitle={t('account')}
          firstContent={[
            `${account?.name} ${account?.surname}`,
            account.phoneNumber
          ]}
          secondTitle={t('company')}
          secondContent={account.companyDesc}
          password="edxwc"
          handleEditPersonalData={
            isDisabled() ? () => null : handleEditAccountData
          }
        />
        {account?.role && (
          <AccountCard
            img={Role}
            firstTitle={t('role')}
            firstContent={`${[...partnerRoleOptions()].find(
              r => r.value === account?.role
            )?.label || ''}`}
            secondTitle={t('account')}
            secondContent={[account.email, '******']}
            handleChangePassword={
              isDisabled() ? () => null : handleChangePassword
            }
          />
        )}
        <AccountCard
          img={Creator}
          firstTitle={t('creator')}
          firstContent={account?.creatorEmail}
          secondTitle={t('creation_date')}
          secondContent={extractDate(account?.createdOn)}
          thirdTitle={
            role === partnerRoles.COMMERCIAL_PARTNER_USER ||
            role === partnerRoles.TECHNICAL_PARTNER_USER
              ? t('team_lead')
              : null
          }
          thirdContent={
            role === partnerRoles.COMMERCIAL_PARTNER_USER ||
            role === partnerRoles.TECHNICAL_PARTNER_USER
              ? account?.teamLeadEmail
              : null
          }
        />
      </CardContainer>
      <EditAccountData account={account} />
      <ChangeAccountPasswordModal />
    </>
  );
};

AccountManagement.propTypes = {
  account: PropTypes.object,
  saveChangePasswordType: PropTypes.func,
  openEditAccountModal: PropTypes.func,
  setError: PropTypes.func,
  clearNotification: PropTypes.func,
  responseStatus: PropTypes.string,
  role: PropTypes.string,
  openChangePasswordModal: PropTypes.func
};

export default connect(
  state => ({
    account: state?.authentication?.accountInfo,
    responseStatus: state?.account?.status,
    role: state?.authentication?.role
  }),
  dispatch => ({
    setError: payload => dispatch(SET_ACCESS_ERROR(payload)),
    openEditAccountModal: payload =>
      dispatch(MODAL_OPEN({ id: 'editAccountData', payload })),
    clearNotification: () => dispatch({ type: 'CLEAR_NOTIFICATION' }),
    openChangePasswordModal: () =>
      dispatch(MODAL_OPEN({ id: 'ChangeAccountPasswordModal' }))
  })
)(AccountManagement);
